import { useContext } from 'react'
import TranslationContext from '../components/TranslationContext';

export const useTranslator = () => {
    const translationContext = useContext(TranslationContext);
    return translationContext ? translationContext.translate : (key, params) => key;

}

